import React, { useState } from "react";
import style from "css/mypage.module.css";
import { DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import Dropbox from "./dropbox";
import { closeAlert, openAlert, openConfirm } from "redux/slices/alertSlice";
import { useDispatch } from "react-redux";
import axios from "axios";
import { useTranslation } from "react-i18next";

function Favoritecard(props) {
  const { t } = useTranslation();
  const [IsHover, setIsHover] = useState(false);
  const dispatch = useDispatch();
  const deletefavorite = () => {
    let params = {
      FAVORITES_ID: props.data.FAVORITES_ID,
    };

    axios
      .put("/schedule/deletefavorite", params)
      .then((res) => {
        if (res.status === 200) {
          const obj = {
            title: t("MESSAGE.NOTIFICATION"),
            content: t("MESSAGE.DELETE_COMPLETE"),
            submitEventHandler: () => {
              props.getScheduleList();
              dispatch(closeAlert());
            },
          };
          dispatch(openAlert(obj));
        }
      })
      .catch((error) => {
        const obj = {
          title: t("MESSAGE.NOTIFICATION"),
          content: t("MESSAGE.ERROR_OCCURRED"),
          submitEventHandler: () => {
            dispatch(closeAlert());
          },
        };
        dispatch(openAlert(obj));
      });
  };
  return (
    <div>
      <div
        className={IsHover ? `${style.itmebox_hover} cursor` : `${style.itmebox} cursor`}
        onMouseOver={() => setIsHover(true)}
        onMouseOut={() => setIsHover(false)}
        onClick={() => props.openpop(props.data)}
      >
        <div className={style.itembox_header}>
          <div className={style.itembox_blue} />
          <div
            className={style.itembox_blue_text + " cursor"}
            onClick={(e) => {
              const obj = {
                title: t("MESSAGE.NOTIFICATION"),
                content: t("MESSAGE.DELETE_SCD"),
                submitEventHandler: () => {
                  deletefavorite();
                  dispatch(closeAlert());
                },
              };
              dispatch(openConfirm(obj));
              e.stopPropagation();
            }}
          >
            <DeleteOutlined style={{ fontSize: "18px", color: "#1cb691" }} />
          </div>
        </div>
        <div
          className={IsHover ? style.itembox_title_hover : style.itembox_title}
        >
          {props.data.TITLE}
        </div>
        <div
          className={
            IsHover ? style.itembox_contents_hover : style.itembox_contents
          }
        >
          {props.data.CONTENTS}
        </div>
        <div
          className={IsHover ? style.itembox_time_hover : style.itembox_time}
        ></div>
        <div className={style.itembox_footer}>
          <div>
            {props.data.PARTICIPANTS !== "" ? (
              <Dropbox
                host="favorite_list"
                count={props.data.PARTICIPANTS.length}
                data={props.data}
                hover={IsHover}
              />
            ) : (
              <div />
            )}
          </div>

          {/* <div
          className={
            IsHover
              ? style.itembox_endpointlist_hover
              : style.itembox_endpointlist
          }
        >
          장비 D 회의실
        </div> */}
        </div>
      </div>
    </div>
  );
}

export default Favoritecard;
